
const getDefaultState = () => {
  return {
    id: null,
    guid: null,
    existingCustomer: 0,
    contracts: [],
    language: 'fr',
    civility: null,
    lastName: null,
    firstName: null,
    birthDate: null,
    mail: null,
    mailRequired: true,
    phone: {
      prefix: '+32',
      number: '',
      type: 'mobile'
    },
    address: {
      exist: 0,
      country: 'BE',
      street: null,
      number: null,
      box: null,
      locality: null
    },
    addressContact: {
      exist: 0,
      country: 'BE',
      street: null,
      number: null,
      box: null,
      locality: null
    },
    sponsorCustomerId: null,
    showSponsor: true,
    hasSponsorAlreadyBeenShown: false,
    customerType: 'resi',
    vatNumber: null,
    companyName: null,
    legalForm: null,
    paymentFrequency: '',
    paymentMode: 'directDebit',
    partialDom: 0,
    iban: null,
    holderCivility: null,
    holderFirstName: null,
    holderLastName: null,
    coholderCivility: null,
    coholderFirstName: null,
    coholderLastName: null,
    agreeDirectDebit: 0,
    receiveInstalement: 0,
    instalmentDayDD: '',
    instalmentDayBT: '',
    bic: null,
    conditions: 0,
    optin: 0,
    optinSales: 0,
    optinTA: false, // ER-710.
    invoiceRemark: null,
    invoiceDeliveryMode: 'email',
    splitInstalments: 0,
    howDoYouKnow: null,
    agentCustomId: null,
    agentCustomRefId: null,
    agentAllowBxlResi: false, // ER-1212.
    agentRestrictedPostalCodes: [],
    providerRequired: false,
    agentCheckEan: null,
    statusScenario: null,
    subscriptionDate: null,
    signatureDate: null,
    isValid: false,
    proposalDate: null,
    promo: null,
    campaign: null,
    origin: null,
    selfService: true,
    showTempContract: true,
    sendRemark: true
  }
}

export default {
  getDefaultState
}



// WEBPACK FOOTER //
// ./src/store/modules/subscription/default.js